import React from 'react';

import {
  ScrollView,
  Text,
  Image,
  TouchableOpacity,
  View,
  Platform,
} from 'react-native';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

/////////////////////// utils

/////////////////////// components
import {BodyText} from 'src/Modules/CommonView';

import {navigationRef} from 'src/Nav/navigationHelpers';

import {useSelector} from 'react-redux';

import {analytics} from 'src/Utils/db';

const Badges = ({
  showEarned = null,
  onlyShowDining,
  backgroundColor = '#F2F2F2',
  showOnlyType = false,
  removeBottomPadding = false,
}) => {
  const {width} = useWindowDimensionsSafe();

  const badgesData = useSelector((state) => state.badges);

  const {badgesEarned = {}, badgesNext = {}} = badgesData || {};

  var formattedBadges = (showEarned ? badgesEarned : badgesNext) || {};

  var sortedBadges = [];

  if (!!showOnlyType && badgesEarned && badgesNext) {
    formattedBadges = {...badgesEarned, ...badgesNext};
  }

  if (!!formattedBadges) {
    sortedBadges = Object.values(formattedBadges);
    sortedBadges = sortedBadges.sort((a, b) => {
      if (!a || !b || a?.id || b?.id) {
        return 1;
      } else {
        const {
          aLevel = 1,
          aCurrent_quantity = 0,
          aRequirement_quantity = 1,
        } = a || {};
        const {
          bLevel = 1,
          bCurrent_quantity = 0,
          bRequirement_quantity = 1,
        } = b || {};
        if (showEarned) {
          return aLevel < bLevel ? 1 : -1;
        } else {
          if (aLevel == bLevel) {
            return (aCurrent_quantity || 0) / (aRequirement_quantity + 1) <
              (bCurrent_quantity || 0) / (bRequirement_quantity + 1)
              ? 1
              : -1;
          } else {
            return aLevel < bLevel ? 1 : -1;
          }
        }
      }
    });
    if (!!showOnlyType) {
      sortedBadges = sortedBadges.filter((badgeItem) => {
        return (
          badgeItem.prize_type == showOnlyType ||
          badgeItem.requirement_type == showOnlyType ||
          badgeItem.type == showOnlyType
        );
      });
    }
  }

  if (Platform.OS == 'web') {
    return console.log('skipping badges for detox or dev');
  }

  return (
    <View style={{flex: 1, paddingTop: 5, backgroundColor}}>
      <ScrollView style={{flex: 1}}>
        {!!sortedBadges &&
          sortedBadges?.map?.((badge, index) => {
            if (onlyShowDining && badge?.type != 'dining_deals') {
              return (
                <View
                  key={`badge list render ${badge?.id || Math?.random()}`}
                />
              );
            }

            //console.log("https://photos.letsroam.com/icons/"+badge.photo_thumb)
            return (
              <Badge
                key={`badge list render ${badge?.id || 1}`}
                title={badge?.title}
                handlePress={() => {
                  if (__DEV__) {
                    // testing badge award
                    const badgeLabel = `${badge?.requirement_type}-${badge?.requirement_quantity}`;
                    analytics().logUnlockAchievement({
                      achievement_id: badgeLabel,
                    });
                  }

                  navigationRef.navigate('BadgeAwardModal', {
                    badge,
                  });
                }}
                task={badge?.task}
                currentAmount={badge?.current_quantity}
                requiredAmount={badge?.requirement_quantity}
                points={badge?.user_points}
                prizeType={badge?.prize_type?.replace('_', ' ')}
                dateAwarded={badge?.date_awarded}
                prizeQuantity={badge?.prize_quantity}
                level={badge?.level}
                backgroundColor={backgroundColor}
                date_awarded={badge?.date_awarded}
                photo={
                  !badge?.photo_thumb?.includes('firebase')
                    ? 'https://photos.letsroam.com/icons/' + badge?.photo_thumb
                    : badge?.photo_thumb
                }
                index={index + 1}
              />
            );
          })}
        {!removeBottomPadding && <View style={{height: 100, width}} />}
      </ScrollView>
    </View>
  );
};

const Badge = ({
  title = '',
  task = '',
  currentAmount,
  backgroundColor,
  requiredAmount,
  prizeType,
  prizeQuantity,
  handlePress,
  photo,
}) => {
  const percentComplete = (currentAmount || 0) / (requiredAmount || 100);
  var formattedPrizeType = prizeType;

  if (prizeType == 'recharge') {
    formattedPrizeType = 'Recharge Deal';
  } else if (prizeType == 'coins') {
    formattedPrizeType = prizeType;
  }
  const {width} = useWindowDimensionsSafe();
  return (
    <TouchableOpacity
      style={{
        marginTop: 5,
        marginBottom: 5,
        width: width - 40,
        marginLeft: 20,
        borderRadius: 9,
        borderColor:
          backgroundColor == global?.color?.white ? global?.color?.gray1 : '',
        borderWidth: backgroundColor == global?.color?.white ? 2 : 0,
        position: 'relative',
        flexDirection: 'row',
        backgroundColor: global?.color?.white,
      }}
      onPress={handlePress}
      disabled={!handlePress}
      activeOpacity={0.8}>
      {/* Left Part of the Badge */}
      <View
        style={{
          width: 100,
          paddingTop: 10,
          paddingBottom: 10,
          alignItems: 'center',
          justifyContent: 'space-around',
          borderRightColor: global?.color?.gray1,
          borderRightWidth: 5,
        }}>
        {/* Badge Icon */}
        <Image source={{uri: photo}} style={{width: 47, height: 47}} />
        {/* numbers plus progress bar */}
        <View
          style={{
            width: 85,
            marginTop: 10,
            height: 20,
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingHorizontal: 2,
            alignItems: 'center',
            // backgroundColor: 'black'
          }}>
          <Text
            style={{
              color: global?.color?.gray3,
              fontSize: currentAmount > 999 ? 10 : 12,
              letterSpacing: currentAmount > 999 ? -2 : -1,
            }}>
            {currentAmount || 0}
          </Text>
          <View
            style={{
              width: 45,
              height: 8,
              marginHorizontal: 2,
              backgroundColor: global?.color?.gray2,
            }}>
            <View
              style={{
                height: 8,
                position: 'absolute',
                left: 0,
                top: 0,
                width: Math?.min(Math?.max(10, 45 * percentComplete), 45),
                backgroundColor: global?.color?.orange,
              }}
            />
          </View>
          <Text
            style={{
              color: global?.color?.gray3,
              fontSize: requiredAmount > 999 ? 10 : 12,
              letterSpacing: requiredAmount > 999 ? -2 : -1,
            }}>
            {requiredAmount || 0}
          </Text>
        </View>
      </View>

      {/* Right Part of the Badge */}
      <View
        style={{
          flex: 1,
          padding: 5,
          paddingLeft: 10,
          paddingRight: 0,
        }}>
        <BodyText
          text={`${title}`}
          textStyle={{
            color: global?.color?.orange,
            fontSize: 16,
            fontWeight: '700',
            letterSpacing: -0.165,
            lineHeight: 20,
            marginLeft: 0,
          }}
        />
        <BodyText
          text={task}
          textStyle={{
            fontSize: 12,
            lineHeight: 18,
            marginTop: 0,
            letterSpacing: -0.265,
            marginLeft: 0,
          }}
        />
        <BodyText
          text={`Prize: ${prizeQuantity} ${formattedPrizeType}`}
          textStyle={{
            color: global?.color?.gray3,
            fontSize: 16,
            letterSpacing: -0.165,
            marginLeft: 0,
            marginRight: 0,
            marginTop: 20,
            marginBottom: 10,
            fontWeight: '700',
          }}
        />
      </View>
    </TouchableOpacity>
  );
};

export default Badges;
